import React, { Component } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

class Captcha extends Component {

  onChange = (value) => {
    if(value.length>0){
      this.props.onClickFunction("captcha",false);
    }
    else{
      this.props.onClickFunction("captcha",true);
    }
  };

  render() {
    return (
      <div>
        <ReCAPTCHA
          sitekey="6Lfk_uoUAAAAAM0_r4a6PWXKv7WWMuxpwEnURBoA"
          onChange={this.onChange}
        />
      </div>
    );
  };
};
export default Captcha;